const React = require("react")
const { navigate } = require("gatsby")

// Logs when the client route changes
exports.onRouteUpdate = ({ location, prevLocation }) => {

    // Default kwargs for the plain /search/ page: land with sortPrice=Lowest
    // applied when there's no query string yet (first visit / cleared filters).
    if (location.pathname === `/search/` && (!location.search || location.search === `?=`)) {
        navigate(`/search/?sortPrice=Lowest`, { replace: true })
        return
    }

    if(prevLocation && (location.pathname !== prevLocation.pathname)){
        window.dataLayer && window.dataLayer.push({'event':'dealermasters-quick-load'});
    }

        if (typeof window !== 'undefined') {
            window.DM = {
                ...(window.DM || {}),
                ready: false,
                pageId: `${location.pathname}${location.search}`
            };
        }
}
